module.exports = __webpack_public_path__ + "static/media/统计.2738a290.svg";